define(function(require,exports,module) {
	var xmlToJson=require('xml-to-json/xml-to-json');

	return function(data, req){
	 	return data && xmlToJson(data.xml||data.responseXML||data.text) || null;
	};
});